import { FormControl, TextField, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface ToggleFormItemProps {
  name: string;
  options: { value: string | boolean; label: string }[];
}

export default function ToggleFormItem({ name, options }: ToggleFormItemProps) {
  const { t } = useTranslation();
  const { watch, control, setValue } = useFormContext();
  const value = watch(name);

  useEffect(() => {
    setValue(name, value);
  }, [value, name]);

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required: true }}
      render={({ field, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error}>
          <ToggleButtonGroup
            value={field.value || value || ""}
            exclusive
            onChange={(_, newValue) => field.onChange(newValue)}
            fullWidth
            sx={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 2 }}
          >
            {options.map((option, index) => (
              <ToggleButton key={index} value={option.value} className="toggleButton">
                {t(option.label)}
              </ToggleButton>
            ))}
            {field && field.value === "other" && (
              <Controller
                name={`${name}Other`}
                control={control}
                rules={{ required: true }}
                render={({ field: customField }) => (
                  <TextField
                    fullWidth
                    margin="normal"
                    variant="filled"
                    label={t("Please specify")}
                    value={customField.value}
                    onChange={customField.onChange}
                    sx={{ height: "48.5px", marginTop: "0" }}
                  />
                )}
              />
            )}
          </ToggleButtonGroup>
        </FormControl>
      )}
    />
  );
}
